/**
 * class {TariffInformation}
 * should be used to display TariffInformation related information.
 * Each Connection has a related TariffInformation which gives Information about the Network and the affected TariffInformations.
 * Perhaps we will store more Information in this Class in the future.
 */
export class TariffInformation {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param network
     * @param fromZone
     * @param toZone
     * @param priceLevel
     */
    constructor(network, fromZone, toZone, zoneStrings, priceLevel) {
        this._network = network;
        this._fromZone = fromZone;
        this._toZone = toZone;
        this._zoneStrings = zoneStrings;
        this._priceLevel = priceLevel;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Line}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.network = values.network !== undefined ? values.network : '';
        sanitizedValues.fromZone = values.fromZone !== undefined ? values.fromZone : 0;
        sanitizedValues.toZone = values.toZone !== undefined ? values.toZone : 0;
        sanitizedValues.zoneStrings = values.zoneStrings !== undefined ? values.zoneStrings : [];
        sanitizedValues.priceLevel = values.priceLevel !== undefined ? values.priceLevel : 0;
        return new TariffInformation(sanitizedValues.network, sanitizedValues.fromZone, sanitizedValues.toZone, sanitizedValues.zoneStrings, sanitizedValues.priceLevel);
    }
    /**
     * gets the internal _network
     * @returns {string}
     */
    get network() {
        return this._network;
    }
    /**
     * sets the internal _network
     * @param value
     */
    set network(value) {
        this._network = value;
    }
    /**
     * gets the fromZone of the TariffInformation
     * @returns {number}
     */
    get fromZone() {
        return this._fromZone;
    }
    /**
     * sets the fromZone of the TariffInformation
     * @param fromZone
     */
    set fromZone(fromZone) {
        this._fromZone = fromZone;
    }
    /**
     * gets the toZone of the TariffInformation
     * @returns {number}
     */
    get toZone() {
        return this._toZone;
    }
    /**
     * sets the toZone of the TariffInformation
     * @param toZone
     */
    set toZone(toZone) {
        this._toZone = toZone;
    }
    /**
     * gets the zoneStrings of the TariffInformation
     * @returns {string[]}
     */
    get zoneStrings() {
        return this._zoneStrings;
    }
    /**
     * sets the zoneStrings of the TariffInformation
     * @param zoneStrings
     */
    set zoneStrings(zoneStrings) {
        this._zoneStrings = zoneStrings;
    }
    /**
     * gets the priceLevel of the TariffInformation
     * @returns {number}
     */
    get priceLevel() {
        return this._priceLevel;
    }
    /**
     * sets the priceLevel of the TariffInformation
     * @param priceLevel
     */
    set priceLevel(priceLevel) {
        this._priceLevel = priceLevel;
    }
}
//# sourceMappingURL=tariffInformation.js.map